export default import.meta.ROLLDOWN_FILE_URL_zqNW_IIpKYGi5s0FprE05g